import dynamic from "next/dynamic";
import { PriceSkeleton } from "./Price";

export default dynamic(() => import("./Price"), {
  ssr: false,
  loading: PriceSkeleton
});
